export interface SEASONAL_MODULE {
    [key: string]: {
        title: string;
        subTitle: string;
        description: string;
        viewMoreUrl: string;
        buckets: string[];
    };
}

export const SEASONAL_FEATURED_MODULE: SEASONAL_MODULE = {
    VALENTINE: {
        title: "Valentine's day your way",
        subTitle: '',
        description: '',
        viewMoreUrl: '/b/local/seasonal/?utm_source=valentines-featured',
        buckets: ['All', 'Music', 'Date Night', 'Hobbies'],
    },
};
